import { FormattedMessage } from 'react-intl';

import * as Styled from './show-more-button.style';

type ShowMoreButtonProps = {
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
  intlKey?: string;
};
const ShowMoreButton: React.FC<ShowMoreButtonProps> = ({
  disabled,
  loading,
  onClick,
  intlKey = 'CP_OTHER_INTERESTING_COMPANIES',
}) => (
  <Styled.PaginationButtonLayout>
    <Styled.PaginationButton
      variant="tertiary"
      disabled={disabled}
      loading={loading}
      onClick={onClick}
    >
      <FormattedMessage id={intlKey} />
    </Styled.PaginationButton>
  </Styled.PaginationButtonLayout>
);

export { ShowMoreButton };
